<template>
	<header id="header">
		<div class="hInner header_notice subHeader">
			<div class="logoWrap">
				<div class="logo"><router-link :to='`/board/${board_type}`'></router-link></div>
				<div class="hLine"></div>
				<div class="hName">공지사항</div>
			</div>
			<button type="button" class="popup_close" @click="commonjs.winClose()"></button>
		</div>
	</header>

	<section id="noticeForm">
		<div class="content content_w noticeForm">
			<div class="contIn">
				<div class="popupInner">
					<form ref="form_board_delete" id="form_board_delete" class="form_board"
						:action="`${SERVER_URL}/api/app/board`" @submit.prevent="form_board_delete_submit()"
						method="post" autocomplete="off">
						<table>
							<tbody>
								<tr>
									<td class="boardCols1">제목</td>
									<td class="boardCols2">
										{{ items.board_subject }}
									</td>
								</tr>
								<tr>
									<td class="boardCols1">작성자</td>
									<td class="boardCols2">{{ items.memberBoard?.mb_name }}</td>
								</tr>
								<tr>
									<td colspan="2" class="boardCols">
										<!-- <div id="bo_v_img">
										</div> -->

										<!-- 본문 내용 시작 -->
										<div id="bo_v_con" v-html="items.board_content"></div>
									</td>
								</tr>
							</tbody>
						</table>
					</form>

					<ul class="notice_BtnWrap subBtn">
						<template v-if="items.mb_boss_id === globaljs.mb_boss_id">
							<li><button type="button" class="edit_btn" @click="goto_url(`/board_edit/${board_type}/${board_id}`)">수정</button></li>
							<li><button type="button" class="edit_btn" @click="form_board_delete_submit()">삭제</button></li>
						</template>
						<li><button type="button" class="list_btn" @click="goto_url(`/board/${board_type}`)">목록</button></li>
					</ul>
				</div>
			</div>
		</div>
	</section>

</template>

<script>
import header from '../components/layout/header.vue'

export default {
	name: 'App',
	components: {
		'include-header': header,
	}
}
</script>

<script setup>
import { env as SERVER_URL } from '@/components/utils/env';
import { onMounted, ref, computed, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import * as globaljs from '@/components/utils/global';
import * as commonjs from '@/components/utils/common';

const route = useRoute();
const router = useRouter();

const props = defineProps({
	type: {
		type: String,
		required: true
	},
	id: {
		type: Number,
		required: true
	},
});

const board_type = ref(props.type);
const board_id = ref(props.id);

watch(
	() => props.type,
	(newVal) => {
		board_type.value = newVal;
	}
);

let submitingFlag = false; // 플래그 변수
const withSubmitFlag = async (asyncFunc) => {
	if (submitingFlag) return; // 요청 중복 방지
		submitingFlag = true; // 요청 시작 시 플래그 설정
	try {
		await asyncFunc(); // 비동기 함수 실행
	} finally {
		submitingFlag = false; // 요청이 끝나면 플래그 해제
	}
};

const goto_url = (url) => {
	router.push(url);
}

const matchingArray = () => {
	const matchingData = items.value.board_field2;
	if (!matchingData) {
		return [];
	}
	return matchingData.split(',').map(item => item.trim());
};

const isActive = (value) => {
	return matchingArray().includes(value);
};

const items = ref([]);

onMounted(async () => {
	await getModels();
});

const getModels = async () => {
	try {
		let response = await axios.get(`${SERVER_URL}/api/app/board/${props.id}`);
console.debug(response.data.result);
		items.value = response.data.result;

		if (items.value.mb_boss_id !== globaljs.mb_boss_id && !isActive(globaljs.mb_boss_id)) {
			Swal.fire({
				title: '권한 없음',
				html: `<div style="word-break: keep-all;">권한이 없습니다. <br/>페이지를 이동합니다.</div>`,
				icon: 'warning',
				confirmButtonText: '확인',
				allowOutsideClick: false,  // 외부 클릭 방지
				allowEscapeKey: false,      // ESC 키 눌러서 닫기 방지
				returnFocus: false,
			}).then((result) => {
				if (result.isConfirmed) {
					setTimeout(function () {
						goto_url(`/board/${props.type}`);
					}, 100);
				}
			});
			return false;
		}
	} catch (error) {
console.error('Error getModels:', error);
	}
}

window.getModels = getModels;

async function form_board_delete_submit() {
	await withSubmitFlag(async () => {
		if (items.value.mb_boss_id !== globaljs.mb_boss_id) {
			Swal.fire({
				title: '권한 없음',
				html: `<div style="word-break: keep-all;">권한이 없습니다. <br/>페이지를 이동합니다.</div>`,
				icon: 'warning',
				confirmButtonText: '확인',
				allowOutsideClick: false,  // 외부 클릭 방지
				allowEscapeKey: false,      // ESC 키 눌러서 닫기 방지
				returnFocus: false,
			}).then((result) => {
				if (result.isConfirmed) {
					setTimeout(function () {
						goto_url(`/board/${props.type}`);
					}, 100);
				}
			});
			return false;
		}

		const is_confirm = await commonjs.confirmSwal('삭제 확인', '게시글을 삭제하시겠습니까?');
		if (!is_confirm) {
			return false;
		}

		const params = new URLSearchParams();
		//params.append('board_type', board_type.value);
		params.append('board_id', board_id.value);

		// URLSearchParams를 객체로 변환
		const object = {};
		params.forEach((value, key) => {
			if (key.endsWith('[]')) {
				const arrayKey = key.slice(0, -2);
				if (!object[arrayKey]) {
					object[arrayKey] = [];
				}
				object[arrayKey].push(value);
			} else {
				object[key] = value;
			}
		});

		// 결과 확인용 로그 출력
		const jsonString = JSON.stringify(object, null, 2); // 들여쓰기 2칸으로 JSON 문자열화
	console.info(jsonString);

		
		try {
			const response = await axios.post(`${SERVER_URL}/api/app/board/del`, params);
	console.debug(response.data.result);
			toast.fire({
				icon: "success",
				title: "공지사항을 삭제했습니다."
			});
			if(opener){
				opener.location.reload();
			}
			router.push("/board/notice");
		} catch (error) {
			console.error(error?.response?.data);
			commonjs.formSwal(`필수 입력`, error?.response?.data?.errors[0]?.msg);
		}
	});
}
</script>

<style scoped>
#bo_v_con {
	white-space: pre-wrap;
	word-wrap: break-word;
}
</style>